<template>
  <div class="homeHead">
    <div class="list" v-for="(item, index) in list" :key="index" :style="{color: item.color}">
      <div class="left">
        <div class="line1">{{item.name}}</div>
        <div class="line2">({{item.unit}})</div>
      </div>
      <div class="right">{{item.value || 0 | formatNumber | isEmptyVal}}</div>
    </div>
  </div>
</template>

<script>
import languageObj from '@/utils/lan.json'
import apiPath from '@config/api.json'
const {mapState} = require('vuex')
export default {
  components: {},

  data () {
    return {
      list: [{
        name: '今日交易额',
        color: '#ECA641',
        unit: '元',
        value: ''
      }, {
        name: '总交易额',
        color: '#2EFE95',
        unit: '元',
        value: ''
      }, {
        name: '企业总数',
        color: '#5A6AFF',
        unit: '家',
        value: ''
      }, {
        name: '店铺总数',
        color: 'rgb(138,63,243)',
        unit: '家',
        value: ''
      }],
      initObj: null // 用于定时器处理
    }
  },

  computed: {
    ...mapState({
      homeTime: (state) => {
        return state.home.homeTime
      }
    })
  },

  watch: {
    homeTime: function (n) {
      this.init()
      this.todaNumber()
    }
  },

  created () {
  },

  mounted () {
    this.init()
    this.todaNumber()
    this.initObj = setInterval(() => {
      this.init()
    }, 60000)
  },

  methods: {
    init () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.home.getDataSummary.getDataSummary}`,
        params: {
          pageIndex: 1,
          pageSize: 10,
          yearTime: this.homeTime
        }
      }).then(res => {
        if (res) {
          let dataInfo = res.data || {}
          if (dataInfo) {
            this.list[1].value = dataInfo.transaction || 0
            this.list[2].value = dataInfo.customerNum || 0
            this.list[3].value = dataInfo.storesNum || 0
          }
        }
      })
    },
    todaNumber () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.home.getDataSummary.getOrderSalesToday}`,
        params: {
          pageIndex: 1,
          pageSize: 10,
          yearTime: this.homeTime
        }
      }).then(res => {
        if (res) {
          let dataInfo = res.data || {}
          if (dataInfo) {
            this.list[0].value = res.data.todayTransaction || 0
          }
        }
      })
    },
    // 设置语言文字
    setLanguageMsg (lan) {
      this.LANMSG = languageObj[lan]
    },
    todayTradeTotalAnimation (val, key) {
      let setNum = 0
      let setObj = setInterval(() => {
        setNum += 9751
        if (setNum > val) {
          setNum = val
          clearInterval(setObj)
        }
        this.list[0].value = setNum
      }, 5)
    }
  },
  beforeDestroy () {
    clearInterval(this.initObj)
  }
}
</script>

<style lang="scss" scoped>
  .homeHead{
    height: 132px;
    width: 100%;
    display: flex;
    // padding: 0 20px;
    align-items: center;
    justify-content: space-around;
    .list{
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      .left{
        margin-right: 20px;
        .line1{
          font-size: 20px;
          margin-bottom:4px;
          white-space: nowrap;
        }
        .line2{
          font-size: 20px;
        }
      }
      .right{
        display: flex;
        align-items: center;
        font-size:48px;
        font-family: arial;
        letter-spacing: 6px;
        div{
          width: 30px;
          height: 66px;
          background: #00083D;
          margin-right: 10px;
          line-height: 66px;
          text-align: center;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/home/compontents/homeHead.vue